import React, { useState, useEffect } from "react";
import StudentTopMenu from "./studenttopmenu";
import { getIdData } from "../../../lib/studentinfo"
import { useNavigate, useParams, Link } from 'react-router-dom';
import StudentInfoBox from "./studentinfobox";

export default function InstructorStudentDetail() {

  const [studentInfo, setStudentInfo] = useState();
  const navigate = useNavigate();
  let { slug } = useParams();

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info);
    console.log("info", info);
  }

  useEffect(() => {
    GetData();
  }, [])
  return (
    <>
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <StudentInfoBox slug={slug}/>
            <StudentTopMenu slug={slug} activeMenu={"Detail"} />
            <div className="settings-widget">
              <div className="settings-inner-blk p-0">
                <div className="checkout-form personal-address add-course-info">
                  <div className="personal-info-head">
                    <h4>Student Details</h4>
                  </div>
                  <form action="#">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-control-label">
                            First Name
                          </label>
                          <p>{studentInfo ? studentInfo[0].name : ""}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-control-label">
                            Last Name
                          </label>
                          <p>{studentInfo ? studentInfo[0].surname : ""}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-control-label">Phone</label>
                          <p>{studentInfo ? studentInfo[0].phone : ""}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-control-label">Email</label>
                          <p>{studentInfo ? studentInfo[0].email : ""}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-control-label">
                            School Name
                          </label>
                          <p>{studentInfo ? studentInfo[0].schoolname : ""}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="form-label">Class</label>
                          <p>{studentInfo ? studentInfo[0].class : ""}</p>
                        </div>
                      </div>
                      <div className="update-profile">
                        <button type="button" disabled className="btn btn-primary" onClick={() => navigate(`/admin/admin-studentstep2/${slug}/Update`)}>
                          Update Profile
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
